import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { deleteConvertedFile } from '../../../state/home.actions';
import { FilesService } from '../../../data/services/files.service';
import { TranslatePipe } from '@ngx-translate/core';
import { JobStatus } from '../../../models/job-status';

@Component({
  selector: 'app-converted-file-card',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './converted-file-card.component.html',
  styleUrl: './converted-file-card.component.scss',
})
export class ConvertedFileCardComponent {
  @Input() fileId: string = '';
  @Input() fileName: string = '';
  @Input() convertedFileName: string = '';
  @Input() fileSize: number = 0;
  @Input() jobId: string = '';
  @Input() status: JobStatus = JobStatus.Wait;
  @Input() fileUrl: string = '';
  store = inject(Store);
  fileService = inject(FilesService);

  protected downloadConvertedFile() {
    return this.fileService.downloadConvertedFile(this.fileId);
  }

  protected deleteConvertedFile() {
    this.store.dispatch(deleteConvertedFile({ fileId: this.fileId }));
  }
}
